
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.2703 6.00002C13.7203 6.95002 14.0503 8.18002 15.0003 8.73002C15.9503 9.28001 17.1803 8.95002 17.7303 8.00002C18.2803 7.05002 17.9503 5.82002 17.0003 5.27002C16.0503 4.72002 14.8203 5.05002 14.2703 6.00002Z' fill='#323232'/><path d='M15.8402 10.41C15.8402 10.41 14.2102 9.47002 13.2402 8.91002C11.1102 7.67002 10.2302 5.08002 11.0602 2.84002C11.2302 2.38002 11.0502 1.87002 10.6302 1.63002C10.1002 1.33002 9.41022 1.56002 9.20022 2.13002C8.25022 4.64002 8.85022 7.48002 10.6602 9.40002L6.01022 17.45C5.73022 17.93 5.90022 18.54 6.38022 18.82C6.86022 19.1 7.47022 18.93 7.75022 18.45L8.75022 16.72L10.4802 17.72L7.98022 22.05C7.70022 22.53 7.87022 23.14 8.35022 23.42C8.83022 23.7 9.44022 23.53 9.72022 23.05L15.5102 13.03C16.4902 14.37 16.7702 16.15 16.1702 17.75C16.0002 18.2 16.1902 18.71 16.6002 18.95C17.1302 19.26 17.8202 19.03 18.0402 18.45C19.0102 15.83 18.4502 12.61 15.8402 10.41Z' fill='#323232'/><path d='M12.7501 3.80002C13.4701 4.21002 14.3801 3.97002 14.8001 3.25002C15.2101 2.53002 14.9701 1.62002 14.2501 1.20002C13.5301 0.790021 12.6201 1.03002 12.2001 1.75002C11.7901 2.47002 12.0301 3.39002 12.7501 3.80002Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-sports-handball`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSportsHandball

    ```js
    <b-new-b-icon-sports-handball />
    ```
</docs>


